import type { ColumnDef } from '@tanstack/react-table';
import { fmtDate, money } from './flow-helpers';
import type { CurrencyCode, FlowTx } from './flow-types';

export const FLOW_COLUMNS = (maxAbs: number, unit: CurrencyCode): ColumnDef<FlowTx, unknown>[] => [
  { accessorKey: 'date', header: 'Date', cell: ({ row }) => <span>{fmtDate(row.original.date, { weekday: 'short', month: 'short', day: 'numeric' })}</span> },
  { accessorKey: 'incoming', header: 'Incoming', cell: ({ row }) => <span className="tabular-nums">{money(row.original.incoming, unit)}</span> },
  { accessorKey: 'outgoing', header: 'Outgoing', cell: ({ row }) => <span className="tabular-nums">{money(row.original.outgoing, unit)}</span> },
  { accessorKey: 'net', header: 'Net flow', cell: ({ row }) => <span className="tabular-nums">{money(row.original.net, unit, 2)}</span> },
  {
    accessorKey: 'net',
    header: 'Net direction',
    enableSorting: false,
    cell: ({ row }) => {
      const pos = row.original.net >= 0;
      const side: React.CSSProperties = pos ? { left: '50%' } : { right: '50%' };
      return (
        <div style={{ position: 'relative', height: 14 }}>
          <div style={{ position: 'absolute', left: '50%', top: -3, bottom: -3, width: 1, background: '#26333e' }} />
          <span
            style={{
              position: 'absolute',
              top: 2,
              bottom: 2,
              borderRadius: 2,
              background: pos ? '#34c4ae' : '#f2866b',
              width: `${(Math.abs(row.original.net) / maxAbs) * 50}%`,
              ...side,
            }}
          />
        </div>
      );
    },
  },
];
